import axios from "axios";
import { baseURL } from "@/config/edv";

console.log(process.env.VUE_APP_API_URL);
const service = axios.create({
  // baseURL: baseURL,
  // baseURL: baseURL,
    baseURL: process.env.VUE_APP_API_URL,
  timeout: 1000 * 60 * 3,
});

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.code !== 200) {
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

export default service;
